import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminAiUsage } from '../../services/getAdminAiUsage.service';

/** Loads the report for an inclusive `{ from, to }` day range. */
export const loadAdminAiUsage = createAsyncThunk(
  'adminAi/loadAdminAiUsage',
  async (range, { rejectWithValue }) => {
    try {
      return await getAdminAiUsage(range);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load AI usage');
    }
  }
);
